import { useQuery } from '@tanstack/react-query'
import { httpGetPhotosetReviewState } from '@/features/host-review/http/host-review.http'
import { QUERY_KEYS } from '@/query-client'

/**
 * The photoset's host review state.
 *
 * This answer gates the whole end-of-post-production screen and holds the step
 * redirect while it is in flight, so it must fail fast: a 404 is already mapped
 * to null, and retrying anything else only delays today's experience from
 * rendering.
 */
export const useGetPhotosetReviewState = (
	photosetId?: number,
	options?: { enabled?: boolean }
) =>
	useQuery({
		queryKey: [QUERY_KEYS.HOST_REVIEW_STATE, photosetId],
		queryFn: () => httpGetPhotosetReviewState(Number(photosetId)),
		enabled: Boolean(photosetId) && options?.enabled !== false,
		retry: false
	})
